import React, { useState, useEffect } from "react";
import { Canvas } from "@react-three/fiber";
import {
  OrbitControls,
  Environment,
  ContactShadows,
  useGLTF,
} from "@react-three/drei";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { homefilterApi } from "../../Services/Operations/ProductAPI";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../Styles/SportsSlider.css";

function Configurator() {
  const { tokenDetails } = useSelector((state) => state.user);
  const [jerseys, setJerseys] = useState([{}, {}]);
  const navigate = useNavigate();
  const handle3d = () => {
    console.log("Don");
    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    }
    navigate("/3d-product");
  };
  useEffect(() => {
    const fetchCricket = async () => {
      try {
        const products = await homefilterApi("cricket");
        console.log("Products for:", products);
        setJerseys(products.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchCricket();
  }, []);
  const settings1 = {
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,

    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1030,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 715,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  };
    const settings2 = {
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,

    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1030,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 715,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  };

  const handleProductClick = (jersey, slug) => {
    console.log("jersey : ", jersey);
    navigate(`/detailsPage/${slug}`);
  };


  return (
    <div>
      <div
        className="cms-section bg-color pos-2 cms-section-default"
        // style={{ backgroundColor: "#f4f4f4" }}
      >
        <div
          className="cms-section-default cms-section-default-yourgame full-width"
          style={{ backgroundColor: "white" }}
        >
          <div className="cms-block block-container-2 pos-0 cms-block-shield-advanced-usps">
            <div className="cms-block-container" style={{}}>
              <div className="cms-block-container-row row cms-row">
                <div className="col-12">
                  <div className="shield-advanced-usps-element">
                    {/* <div
                      className="shield-advanced-usps-inner block-container"
                      style={{ marginBottom: "0px" }}
                    >
                      <h2
                        className="t1 large1"
                        style={{ marginBottom: "0px", marginTop: "18px" }}
                      >
                        Your Game, Your Style
                      </h2>
                      <div
                        className="image-text-slider-element cms-element-shield-advanced-usps"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          className="usp-list-item"
                          style={{
                            flex: "1 1 calc(25% - 20px)",
                            margin: "10px",
                            height: "290.75px",
                          }}
                        >
                          <div
                            className="usp-list-wrapper"
                            style={{ padding: "20px" }}
                          >
                            <div className="image-container">
                              <img
                                src="/asset/icon4.svg"
                                className="img-fluid image-slider-image f_lazy desctop-image-view desctop-type"
                                width="50"
                                height="50"
                                alt="Endless Customization Options"
                              />
                            </div>
                            <div className="info-block">
                              <p
                                className="title t2 middle1 minimum-elipis"
                                style={{
                                  padding: "0px 0px",
                                  height: "auto",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "95%",
                                  display: "inline-block",
                                }}
                              >
                                Design Your Own Gear
                              </p>
                              <p className="description small1" style={{
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "95%"
}}>
                                Use our advanced 3D configurator to create
                                custom jerseys, shorts, hoodies, and more.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div
                          className="usp-list-item"
                          style={{
                            flex: "1 1 calc(25% - 20px)",
                            margin: "10px",
                            height: "290.75px",
                          }}
                        >
                          <div
                            className="usp-list-wrapper"
                            style={{ padding: "20px" }}
                          >
                            <div className="image-container">
                              <img
                                src="/asset/icon1.svg"
                                className="img-fluid image-slider-image f_lazy desctop-image-view desctop-type"
                                width="50"
                                height="50"
                                alt="Order Any Quantity—No Minimums!"
                              />
                            </div>
                            <div className="info-block">
                              <p
                                className="title t2 minimum-elipis"
                                style={{ padding: "0px 0px", height: "auto", whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "95%",
                                  display: "inline-block", }}
                              >
                                No Minimum Order Quantity
                              </p>
                              <p className="description small1" style={{
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "95%"
}}>
                                Order as few as one piece and get the same
                                professional quality.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div
                          className="usp-list-item"
                          style={{
                            flex: "1 1 calc(25% - 20px)",
                            margin: "10px",
                            height: "290.75px",
                          }}
                        >
                          <div
                            className="usp-list-wrapper"
                            style={{ padding: "20px" }}
                          >
                            <div className="image-container">
                              <img
                                src="/asset/icon2.svg"
                                className="img-fluid image-slider-image f_lazy desctop-image-view desctop-type"
                                width="50"
                                height="50"
                                alt="All-Inclusive Pricing"
                              />
                            </div>
                            <div className="info-block">
                              <p
                                className="title t2 minimum-elipis"
                                style={{ padding: "0px 0px", height: "auto", whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "95%",
                                  display: "inline-block", }}
                              >
                                Fast & Reliable Delivery
                              </p>
                              <p className="description small1" style={{
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "95%"
}}>
                                We offer express shipping options to meet urgent
                                deadlines.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div
                          className="usp-list-item"
                          style={{
                            flex: "1 1 calc(25% - 20px)",
                            margin: "10px",
                            height: "290.75px",
                          }}
                        >
                          <div
                            className="usp-list-wrapper"
                            style={{ padding: "20px" }}
                          >
                            <div className="image-container">
                              <img
                                src="/asset/icon.svg"
                                className="img-fluid image-slider-image f_lazy desctop-image-view desctop-type"
                                width="50"
                                height="50"
                                alt="All-Inclusive Pricing"
                              />
                            </div>
                            <div className="info-block">
                              <p
                                className="title t2 minimum-elipis"
                                style={{ padding: "0px 0px", height: "auto", whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "95%",
                                  display: "inline-block", }}
                              >
                                100% Quality Assurance
                              </p>
                              <p className="description small1" style={{
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "95%"
}}>
                                Made from durable, high-performance materials
                                designed for every sport.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div style={{display:"flex"}}>
      {[1,2,3,4,5,6].map(n=><img
        alt="Best of Beauty Banner"
        style={{
          margin: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width:window.innerWidth<567?"100px":"250px",
          height:"auto"
        }}
        class=""
        loading="lazy"
        src="\asset\img\home-ticket-3.png"
      />)}
      </div> */}




        {window.innerWidth>657?
        <div style={{width:"screen", backgroundColor:"#fae7a9ff",padding:"50px"}}>
          <p style={{fontSize:"48px",fontWeight:400,color:"black"}}>Why Order from Shield Sports?</p>
          <div style={{paddingLeft:"50px",display:"flex",width:"100%",color:"white",alignItems:"start"}}>
            <div  style={{width:"65%",borderRadius:"10px",paddingRight:"25px",maxHeight:"65vh",minHeight:"65vh",display:"flex",flexDirection:"column",gap:"3vh"}}>
              <div style={{display:"flex",width:"100%",justifyContent:"space-between",maxHeight:"31vh",minHeight:"31vh"
              }}>
                <div style={{width:"48%",backgroundColor:"black",borderRadius:"10px",padding:"25px"}}>
                  <p>Trusted by Thousands</p>
                  <p style={{fontWeight:300,fontSize:"16px"}}>Rated 4.8/5 on Google, we provide end-to-end transparency, from design to delivery.</p>
                </div>
                <div style={{width:"48%",backgroundColor:"black",borderRadius:"10px",padding:"25px"}}>
                  <p>Incredible Bulk Discounts</p>
                  <p style={{fontWeight:300,fontSize:"16px"}}>We build long-term partnerships by offering exclusive team and corporate pricing.</p>
                </div>
              </div>
              <div style={{width:"100%",backgroundColor:"black",borderRadius:"10px",padding:"25px",maxHeight:"31vh",minHeight:"31vh"
              }}>
                <p>Worldwide Shipping</p>
                <p style={{fontWeight:300,fontSize:"16px"}}>
                  No matter where you are in the world, we believe your personalized jersey should reach you without hassle.
                   That’s why we proudly offer global shipping, ensuring that your custom-designed jerseys can be
                   delivered to your doorstep — whether you’re in a bustling city or a quiet town.
                </p>

              </div>
            </div>
            <div style={{width:"30%",backgroundColor:"black",borderRadius:"10px",padding:"25px",maxHeight:"65vh",minHeight:"65vh"}}>
              <p>Fast & Secure Payments</p>

              <p style={{fontWeight:300,fontSize:"16px"}}>We believe that your transaction experience should be as smooth and worry-free as the service itself.
                 That’s why we’ve integrated a wide range of fast, reliable, and secure payment options tailored to suit
                  your preferences — whether it’s UPI,
                 debit/credit cards, PayPal, or mobile wallets.</p>

            </div>
          </div>
        </div>
        :
         ""
        }


      {/* <div
        className="cms-block block-container-2 pos-1 cms-block-image-cover"
        style={{ position: "relative" }}
      >
        <div className="cms-block-container">
          <div className="cms-block-container-row row cms-row ">
            <div
              className="col-12"
              data-cms-element-id="0191992ef05d7605879d0b8fc6d36856"
            >
              <div className="cms-element-image justify-content-start">
                <div
                  className="cms-video-container is-cover"
                  style={{ cursor: "pointer" }}
                >
                  
                  <img
                    onClick={() => {
                      handle3d();
                    }}
                    src="/Images/BannerSports3.webp"
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div
        style={{
          backgroundColor: "white",
          padding: "10px 20px 0px",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
      >
        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <p
                style={{fontSize:window.innerWidth <= 567?"18px":"48px" ,color:"black",fontWeight:window.innerWidth <= 567?700:500,padding: window.innerWidth <= 567?"5px":"20px",textAlign:window.innerWidth <= 567?"center":"center"}} 
              >
                Latest Cricket Jerseys
                 <br/>
               {window.innerWidth<567 &&  <span style={{fontFamily:"Poppins",color:"gray",fontSize:"12px",textAlign:"center",fontWeight:"normal"}}>
                  Book your Cricket team jersey</span>}
              </p>

      { window.innerWidth>567  &&  <Slider {...settings1} className="jersey-slider" style={{backgroundColor:"white"}}>
            {jerseys.map((jersey) => {
              const discount =
                jersey.size && jersey.size.length > 0
                  ? jersey.size[0].discount_percent
                  : 0;
              const price =
                jersey.size && jersey.size.length > 0
                  ? jersey.size[0].price
                  : 0;
              const mrp =
                jersey.size && jersey.size.length > 0 ? jersey.size[0].mrp : 0;

                function limitTextToWords(text, wordLimit) {
                   if (typeof text !== 'string') return '';
  const words = text.trim().split(/\s+/); // split by whitespace
  if (words.length <= wordLimit) return text;
  return words.slice(0, wordLimit).join(' ') + '...';
}

              return (
                <div
                  key={jersey.id}
                  style={{
                    padding: "0 8px",
                    background: "linear-gradient(white, rgb(255, 230, 255))",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      overflow: "hidden",
                      // width:"330",
                  
                      transition: "all 0.3s ease",
                      transform: "translateY(0)",
                     
                      position: "relative",
                    }}
                    className="jersey-card"
                    
                  >
                    <div
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        height: "235px",
                        // width:"270px"
                      }}
                    >
                      <img
                        src={jersey.image}
                        alt={jersey.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          transition: "transform 0.5s ease",
                          borderRadius: "0px",
                         
                        }}
                        className="jersey-image"
                      />
                        <img style={{position:"absolute",top:5,right:5,width:"25px"}}
                      src="/asset/img/heart.png"/>
                       <p style={{position:"absolute",borderRadius:"5px",top:0,left:0,fontSize:'10px',padding:"5px",background:"linear-gradient(to right, #ee1e03ff, #e7a109ff)",color:"white"}}>
                        New Arrival</p>
                    </div>

                   <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between",height:"150px"}} > 
                          <div style={{ padding: "3px",paddingLeft:'10px',paddingRight:"10px" }}>
                            <p
                              style={{
                                fontSize: "16px",
                                fontWeight: 700,
                                fontStyle:"bold",
                                
                                marginBottom: "4px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                fontFamily:"inherit",
                                textOverflow: "ellipsis",
                                color:"black"
                              }}
                            >
                              {jersey.name}
                            </p>
                            <p style={{fontSize:"12px",fontWeight:"bold",color:"gray", marginBottom: "0.4rem",}}>
                              {limitTextToWords(jersey.name,10)  }
                            </p>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                marginBottom: "4px",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "20px",
                                  fontWeight: 700,
                                  fontStyle:"bold",
                                  color: "black",
                                  fontFamily:"ITF Devanagari"
                                }}
                              >
                                ${price}
                              </span>
                              <span
                                style={{
                                  fontSize: "15px",
                                  color: "#686767ff",
                                  textDecoration: "line-through",
                                   fontFamily:"ITF Devanagari"
                                }}
                              >
                                ${mrp}
                              </span>
                              <span
                                style={{width:"51px",height:"17px",borderRadius:"20px",backgroundColor:"#F1A3A3",
                                  color:"#CE0505",
                                   fontSize: "11px",textAlign:"center" }}
                              >
                               {"-"} {Math.round(((mrp - price) / mrp) * 100)}%
                              </span>
                            </div>
                            </div>
                            <p  onClick={(e) => {
                            e.preventDefault();
                            handleProductClick(jersey, jersey.slug);
                          }}
                            style={{marginLeft:"9px",cursor:"pointer",borderBottom:"1.5px solid black",width:"fit-content",fontSize:'15px',fontWeight:"bold"}}>Shop Now
                            </p>
                          </div>
                  </div>
                </div>
              );
            })}
          </Slider>}

          {window.innerWidth <= 567 && 
                           <Slider {...settings1} className="jersey-slider" style={{backgroundColor:"white"}}>
                                      {jerseys.map((jersey) => {
                                        const discount =
                                          jersey.size && jersey.size.length > 0
                                            ? jersey.size[0].discount_percent
                                            : 0;
                                        const price =
                                          jersey.size && jersey.size.length > 0
                                            ? jersey.size[0].price
                                            : 0;
                                        const mrp =
                                          jersey.size && jersey.size.length > 0 ? jersey.size[0].mrp : 0;
                          
                                        return (
                                          <div
                                            key={jersey.id}
                                            style={{
                                              padding: "0 8px",
                                              background: "linear-gradient(white, rgb(255, 230, 255))",
                                            }}
                                          >
                                            <div
                                              style={{
                                                backgroundColor: "#ffffff",
                                                borderRadius: "8px",
                                                overflow: "hidden",
                                                width:"330",
                                            
                                                transition: "all 0.3s ease",
                                                transform: "translateY(0)",
                                               display:"flex",
                                                flexDirection:"column",
                                                justifyContent:"space-between",
                                                position: "relative",
                                              }}
                                              className="jersey-card"
                                              
                                            >
                                              <div
                                                style={{
                                                  position: "relative",
                                                  overflow: "hidden",
                                                  height: "180px",
                                                  width:"240"
                                                }}
                                              >
                                                <img
                                                  src={jersey.image}
                                                  alt={jersey.name}
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "contain",
                                                    transition: "transform 0.5s ease",
                                                    borderRadius: "0px",
                                                  }}
                                                  className="jersey-image"
                                                />
                                                  <img style={{position:"absolute",top:5,right:5,width:"25px"}}
                                                src="/asset/img/heart.png"/>
                                                <p style={{position:"absolute",borderRadius:"5px",top:0,left:0,fontSize:'10px',padding:"5px",background:"linear-gradient(to right, #ee1e03ff, #e7a109ff)",color:"white"}}>
                        New Arrival</p>
                                              </div>
                          
                                              <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between",height:"40%" }}>
                                                <div>
                                                <p
                                                  style={{
                                                    fontSize: "12px",
                                                    fontWeight: 700,
                                                    fontStyle:"bold",
                                                    color: "#000000ff",
                                                    marginBottom: "4px",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                  }}
                                                  onClick={(e) => {
                                                      e.preventDefault();
                                                      handleProductClick(jersey, jersey.slug);
                                                    }}
                                                >
                                                  {jersey.name}
                                                </p>
                                                <p style={{fontSize:"8px",fontWeight:"bold",color:"gray"}}>{jersey.name}</p>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    marginBottom: "4px",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      fontSize: "12px",
                                                      fontWeight: 700,
                                                      fontStyle:"bold",
                                                      color: "black",
                                                     fontFamily:"ITF Devanagari"
                                                    }}
                                                  >
                                                    ${price}
                                                  </span>
                                                  <span
                                                    style={{
                                                      fontSize: "10px",
                                                      color: "#504f50ff",
                                                      fontWeight:700,
                                                      fontStyle:"bold",
                                                      textDecoration: "line-through",
                                                      fontFamily:"ITF Devanagari"
                                                    }}
                                                  >
                                                    ${mrp}
                                                  </span>
                                                  <span style={{width:"25px",height:"10px",borderRadius:"20px",textAlign:"center",
                                                     fontSize: "7px", color: "#CE0505",backgroundColor:"#F1A3A3" }}>
                                                    {"-"}{Math.round(((mrp - price) / mrp) * 100)}%
                                                  </span>
                                                </div>
                                                </div>
                                                <p  onClick={(e) => {
                                                      e.preventDefault();
                                                      handleProductClick(jersey, jersey.slug);
                                                    }}
                                                      style={{cursor:'pointer',borderBottom:"1.5px solid black",width:"fit-content",fontSize:'12px',fontWeight:"bold"}}>Shop Now
                                                      </p>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      })}
                             </Slider>}
        </div>

        <style jsx global>{`
          .jersey-slider .slick-prev:before,
          .jersey-slider .slick-next:before {
            color: #4f46e5;
            font-size: 24px;
          }
            .slick-list{
            background-color:white
            }

          .jersey-slider .slick-dots li button:before {
            font-size: 12px;
            color: #4f46e5;
          }

          .jersey-slider .slick-dots li.slick-active button:before {
            color: #4f46e5;
            opacity: 1;
          }

          .jersey-slider .slick-slide {
            padding: 0 10px;
          }

          .jersey-card:hover {
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
              0 10px 10px -5px rgba(0, 0, 0, 0.04);
            transform: translateY(-4px);
          }

          .jersey-image:hover {
            transform: scale(1.05);
          }
        `}</style>
      </div>


    
    </div>
  );
}

export default Configurator;
